import { ReactNode, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Icon from "../../assets/components/icon";

import AuthContext from "../../context/auth";
import { capitalizeFirstLetter } from "../../hooks/helpers/helpers";
import { UserMenu } from "../../types/authTypes";

const TopBar = ({ children }: { children: ReactNode }) => {
  const { pathname } = useLocation();
  const { userMenu } = useContext(AuthContext);

  const [pathName, setPathName] = useState({
    name: "",
    icon: "",
  });

  const menu = userMenu as unknown as UserMenu[];

  useEffect(() => {
    if (userMenu) {
      menu?.find((menu: any) => {
        return (
          `/${menu.to}` === pathname &&
          setPathName({
            name: menu.to,
            icon: menu.icon,
          })
        );
      });
    }
  }, [pathname, userMenu, menu]);

  return (
    <div>
      <div className="main-top-bar shadow">{children}</div>

      <div className="main-bread-crumbs px-3">
        <Icon
          icon={pathName.icon}
          className="filter-green"
          style={{ width: "16px" }}
        />
        &nbsp; {`/ ${capitalizeFirstLetter(pathName.name)}`}
      </div>
    </div>
  );
};

export default TopBar;
